/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { action, extendObservable } from 'mobx';
import { createResourceStoreHouse } from 'src/luis/core/stores/resourceStoreHouse';
import { ResourceStoreHouse } from 'src/luis/types/stores/core/ResourceStoreHouse';
import { PhraseListStore } from 'src/luis/types/stores/features/PhraseListStore';
import { PhraseListStoreHouse } from 'src/luis/types/stores/features/PhraseListStoreHouse';
import { SubtractStore } from 'src/luis/types/SubtractStore';

/**
 * A factory function for creating an phrase list store house,
 * which houses an array of phrase list stores.
 */
export const createPhraseListStoreHouse = (): PhraseListStoreHouse => {
    const resourcesStoreHouse = createResourceStoreHouse<PhraseListStore>();

    const phraseListStoreHouse: SubtractStore<PhraseListStoreHouse, ResourceStoreHouse<PhraseListStore>> = {
        /**
         * Finds an phrase list by the given name and returns undefined
         * if not found.
         *
         * @param name The name to search with.
         * @returns The phrase list or undefined if not found.
         */
        findByName(name: string): PhraseListStore {
            return this.items.find(i => i.name === name);
        }
    };

    return extendObservable(resourcesStoreHouse, phraseListStoreHouse, { findByName: action }, { deep: false });
};
